import { useEffect, useMemo } from "react";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import ServiceAccordion from "./ServiceAccordion";
import { useDashboardUIContext } from "@contexts/dashboardUI";
import TableItem from "./TableItem";
import ProjectionLoadState from "../ProjectionLoadState";

const SubstepAccordion = ({ parent }) => {

  const { barChartDate } = useDashboardUIContext()
  const { activeProject: { _id, substeps = {} }, filterDates } = useProjectContext();
  const { loadSubsteps } = useProjectActions();

  useEffect(() => {
    if (_id) {
      loadSubsteps(parent, barChartDate);
    }
  }, [_id, filterDates, barChartDate])

  const stepSubsteps = useMemo(() => substeps[parent], [parent, substeps])

  return (
    <>
      <ProjectionLoadState
        level="substeps"
        parent={parent}
        isMissing={!stepSubsteps}
        onRetry={() => loadSubsteps(parent, barChartDate)}
      />
      {stepSubsteps?.map((item, index) => <TableItem key={index} item={item} type={"substep"} typeTitle={"Subetapa"} ChildAccordionComponent={ServiceAccordion} />)}
    </>
  )
}

export default SubstepAccordion;
